export default "mutation {\n  completeCurrentOrder {\n    state\n    errors\n  }\n}\n"